import { inject, Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { map, merge, Observable, of } from 'rxjs';
import { LanguageService } from '../../core';


/**
 * Pipe to display validation message.
 */
@Pipe({
	name: 'validationMsg'
})
export class ValidationMessagePipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);

	private _validationMsgs: { [key: string]: string[] } | null = null;

	transform(control: AbstractControl | null, validationMsgs: { [key: string]: string[] } | null): Observable<string | null> {
		if (!control) return of(null);
		this._validationMsgs = validationMsgs;
		return merge(
			of(this.handleError(control)),
			control.valueChanges.pipe(map(() => this.handleError(control)))
		);
	}

	private handleError(control: AbstractControl): string | null {
		return control.status == 'INVALID' ? this.getErrorMessage(control.errors) : null;
	}

	private getErrorMessage(errors: ValidationErrors | null): string {
		if (errors) {
			let res = '';
			const firstKey = Object.keys(errors)[0];
			const errMsg = this._validationMsgs?.[firstKey];
			if (errMsg?.length) {
				res = this.langSrv.labels()[errMsg[0]];
				for (let index = 1; index < errMsg.length; index++) {
					res = res.replace(`{{${index}}}`, errMsg[index]);
				}
			}
			return res;
		}
		return ''
	}
}
